import { styled } from 'styled-components';

import { spacing } from '../../../styles/spacing';
import { bannerStyle } from '../common/commonStyles';
import { Flex } from '../../Layout';
import { Headings } from '../../Headings';
import { Text } from '../../Text';
import { useIsDeviceSize } from '../../Media';
import { Link } from '../../Link';

const Banner = styled.header`
  ${bannerStyle}
  justify-content: center;

  padding: 40px 40px;
  @media (max-width: ${spacing.breakpoint.lg - 1}px) {
  }
`;

type TitleBannerProps = { title: string; subtitle: string; link?: { name: string; to: string } };

export const TitleBanner = ({ title, subtitle, link }: TitleBannerProps) => {
  const { isDesktop } = useIsDeviceSize();

  return (
    <Banner>
      <Flex width="100%" maxWidth={990} flexDirection={['column', 'column', 'row']} alignItems="center">
        <Flex
          maxWidth={[990, 990, 784]}
          flexDirection="column"
          rowGap={10}
          alignItems={isDesktop ? 'flex-start' : 'center'}
        >
          <Headings.H1 color="white" textAlign={isDesktop ? 'left' : 'center'}>
            {title}
          </Headings.H1>
          <Text color="white" textAlign={isDesktop ? 'left' : 'center'} style={preambleTextStyle}>
            {subtitle}
          </Text>
          {link && (
            <Link
              to={link.to}
              variant="transparent"
              style={{
                fontSize: '22px',
                textDecoration: 'underline',
                textAlign: isDesktop ? 'left' : 'center',
              }}
              hasIcon={isDesktop}
            >
              {link.name}
            </Link>
          )}
        </Flex>
      </Flex>
    </Banner>
  );
};

// Task 117704: FE: Add way to turn off responsive fonts
const preambleTextStyle = {
  fontSize: '22px',
};
